// src/components/FavoriteList.jsx
import React, { useEffect, useState } from 'react';
import { Container, Typography, Box } from '@mui/material';
import { fetchNews, fetchSavedNewsIds } from '../lib/api';
import { getCurrentUser } from '../lib/auth';
import NewsCard from './NewsCard';

const FavoriteList = () => {
  const currentUser = getCurrentUser();
  const currentUserEmail = currentUser?.email || null;

  const [savedIds, setSavedIds] = useState([]);
  const [savedArticles, setSavedArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const limit = 100;

  useEffect(() => {
    loadFavorites();
  }, []);

  const loadFavorites = async () => {
    try {
      const ids = await fetchSavedNewsIds();
      setSavedIds(ids);

      if (ids.length === 0) {
        setSavedArticles([]);
        return;
      }

      const fetched = await fetchNews(0, limit); // 🔹 全記事取得
      const filtered = fetched.filter((a) => ids.includes(a.id));
      setSavedArticles(filtered);
    } catch (err) {
      console.error("お気に入りニュースの取得に失敗:", err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Container sx={{ py: 4, textAlign: 'center' }}>
        <Typography sx={{ fontSize: '0.82rem', fontFamily: 'inherit', color: '#a8a29e' }}>読み込み中...</Typography>
      </Container>
    );
  }

  return (
    <Container sx={{ py: 4, maxWidth: '760px !important' }}>
      <Typography sx={{ fontWeight: 800, fontSize: '1.1rem', fontFamily: 'inherit', color: '#1c1916', mb: 0.5 }}>
        Saved Stories
      </Typography>
      <Box sx={{ borderTop: '1px solid #ccc8c2', mt: 1.5 }}>
        {savedArticles.length === 0 ? (
          <Typography sx={{ fontSize: '0.82rem', fontFamily: 'inherit', color: '#a8a29e', py: 4 }}>
            保存済みの記事はありません。
          </Typography>
        ) : (
          savedArticles.map((article, index) => (
            <NewsCard
              key={article.id}
              article={article}
              index={index + 1}
              isSaved={true}
              onSaveArticle={() => {}}
              selectedSite={null}
              onFilterBySite={() => {}}
              currentUserEmail={currentUserEmail}
            />
          ))
        )}
      </Box>
    </Container>
  );
};

export default FavoriteList;
